<template>
	<div class="aboutContent">
		<div class="businessUp">
			<div style="padding-top: 50px;text-align: center;font-size: 26px;font-weight: 900;color: white;">业务领域</div>
			<div style="color: white;font-size: 14px;text-align: center;">Business Area</div>
			<!-- <div style="text-align: center;color: white;padding-top: 25px;font-size: 14px;line-height: 32px;">国内长期从事不良资产业务的律师事务所之一。本部律师不仅在合同法、公司法、物权法等领域具有深厚的理论功底及丰富的实践经验，</div>
			<div style="text-align: center;color: white;font-size: 14px;line-height: 32px;">更长期服务于国内各大商业银行、资产管理公司、投资公司等知名金融机构，与资金方、资产方及通道方均有良好的合作关系。不良资产业务部律师深谙</div>
			<div style="text-align: center;color: white;font-size: 14px;line-height: 32px;padding-bottom: 50px;">不良资产处置的行业特性。</div> -->
				
			<div style="text-align: center;color: white;padding-top: 25px;font-size: 14px;line-height: 32px;">以客户需求为中心的专业化服务是我们保持现有客户及不断赢得新客户和新业务的根本保证。</div>
			<div style="text-align: center;color: white;font-size: 14px;line-height: 32px;">和华利盛全新的、多方面的、专业化的解决方案使得大量领先公司、金融机构等得到有力的法律支持。</div>
			<div style="text-align: center;color: white;font-size: 14px;line-height: 32px;padding-bottom: 50px;">政府组织及社会机构也从我们这里获得了创造性支援。</div>
		</div>
		<div class="businessBottom">
			<div v-for="(item,index) in tableData[tableIndex]" :key="index" class="businessHover">
				<div :style="{'margin-right':(index!=2&&index !=5)?'5%':'0',left:(index == 0 || index == 3)?0:((index == 1||index==4)?'35%':'70%'),bottom:(index == 0||index==1||index==2)?'-240px':'-480px'}" class="bottomShow">
					<img :src="item.icon1" style="padding-top: 40px;">
					<div style="padding-top: 20px;font-size: 18px;font-weight: 100;">{{item.title}}</div>
					<div style="font-size: 12px;padding-top: 5px;color: #A4A4A4;">{{item.e_title}}</div>
				</div>
				
				<div :style="{'margin-right':(index!=2&&index !=5)?'5%':'0',left:(index == 0 || index == 3)?0:((index == 1||index==4)?'35%':'70%'),bottom:(index == 0||index==1||index==2)?'-240px':'-480px'}" class="bottomNone">
					<img :src="item.icon2" style="padding-top: 40px;">
					<div style="padding-top: 20px;font-size: 18px;font-weight: 100;color: white;">{{item.title}}</div>
					<div style="font-size: 12px;padding-top: 5px;color: white;">{{item.e_title}}</div>
					<div @click="toDetail(item)" style="font-size: 14px;margin-top: 15px;width: 100px;height: 32px;border: 1px solid white;color: white;vertical-align: middle;display: inline-block;line-height: 32px;border-radius: 25px;cursor: pointer;">查看详情</div>
				</div>
			</div>
		</div>
		<div style="margin-top: 30px;width: 64%;text-align: center;position: absolute;z-index: 999999;height:100px">
			<div @click="serviceUp" style="display: inline;margin-right: 20px;">
				<img style="width: 30px;height: 30px;border: 1px solid #98273A;padding: 2px;border-radius: 30px;cursor: pointer;" src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%B7%A6%E7%AE%AD%E5%A4%B4.png">
			</div>
			<div @click="serviceDown" style="margin-left: 20px;display: inline;">
				<img style="width: 30px;height: 30px;border: 1px solid #98273A;padding: 2px;border-radius: 30px;cursor: pointer;" src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/%E5%8F%B3%E7%AE%AD%E5%A4%B4.png">
			</div>
		</div>
	</div>
</template>

<script>

	import {del,query} from "@/api/service";
	export default{
		data() {
			return {
				tableData: [],
				tableIndex:0,
				tableMaxIndex:0
			}
		},
		mounted() {
			this.list()
		},
		methods:{
			toDetail(item){
				this.$router.push(
					{
						path:'/businessAreaDetail',
						query:{
							id:item.id
						}
					}
				);
			},
			serviceUp(){
				if(this.tableIndex == 0 && this.tableMaxIndex > 0){
					this.tableIndex = this.tableMaxIndex
				}else if(this.tableMaxIndex > 0){
					this.tableIndex = this.tableIndex - 1;
				}
			},
			serviceDown(){
				if(this.tableIndex == this.tableMaxIndex){
					this.tableIndex = 0;
				}else if(this.tableMaxIndex > 0){
					this.tableIndex = this.tableIndex + 1;
				}
			},
			//查询栏目列表
			list() {
				let param = {
					page: 1,
					pageSize: 99999,
				}
				query(param).then(data => {
					let temList = []
					let index = 0;
					for(let i=0;i<data.data.list.length;i++){
						if(i != 0 && i%6 == 0){
							this.tableData.push(temList)
							index++;
							temList = []
						}
						temList.push(data.data.list[i])
						
					}
					if(temList && temList.length>0){
						this.tableData.push(temList)
						index++;
					}
					this.tableMaxIndex = (index - 1)
					this.tableIndex = 0
					console.log(this.tableData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
			goAbout(){
				this.$router.push({
					path: "/channel_detail/"+'4',
				})
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.businessHover{
		position: relative;
    perspective: 1000px;
	}
	.bottomShow{
		width: 30%;
    float: left;
    text-align: center;
		position: absolute;
		border-bottom: 2px solid #98273A;
		height: 240px;
		opacity:1;
    transition: all 1s ease-in-out 0s;
	}
	.businessHover:hover .bottomShow{
    opacity:0;
	}
	.businessHover:hover .bottomNone{
		opacity:1;
		height: 240px;
	}
	.bottomNone{
		// display: none;
		position:absolute;
		width: 30%;
    float: left;
    text-align: center;
		background-color:#98273A;
		opacity:0;
		height: 0px;
    transition: all 0.50s ease-in-out 0s;
	}

	@media only screen and (max-width: 990px){
    .box{  margin-bottom:20px; }
	}

	.businessUp{
		background: url('https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/indexAboutUs.png') no-repeat;
		background-size:100% 100%;
		width: 100%;
	}
	.businessBottom{
		width: 100%;
		height: 480px;
	}
	.aboutContent{

		width: 64%;
		padding: 30px 18%;
		padding-top: 150px;
		// display: flex;
		flex-direction: row;
		// justify-content: space-between;
		.left{
			width: 36%;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			.cmpName{
				width: 100%;
				height: 50px;
				font-size: 28px;
				font-family: Adobe Heiti Std R;
				color: #2E2E2E;
				line-height: 33px;
				border-bottom: 2px solid #469DFF;
			}
			.cmpInfo{
				width: 600px;
				padding: 10px 0;
				font-size: 21px;
				font-family: Adobe Heiti Std R;
				color: #838383;
				line-height: 33px;
			}
			.button{
				width: 120px;
				height: 36px;
				color: #FFFFFF;
				font-size: 16px;
				line-height: 36px;
				text-align: center;
				border-radius: 20px;
				background-color: #1A86FF;
				cursor: pointer;
				margin-top: 20px;
			}
		}
		.right{
		padding-left: 7%;
    height: 100%;
		}
	}
</style>
